import { useFAQ } from "~/components/institutional/FAQ/useFAQ"

export default function SearchResult() {
    const { search } = useFAQ()

    if (!search.query) return null

    if (!search.result?.length) {
        return (
            <div className='max-w-[1134px] px-5 mx-auto my-10'>
                <h3 className='text-xl font-bold'>
                    Nenhum resultado encontrado
                </h3>
            </div>
        )
    }

    return (
        <div className='max-w-[1134px] px-5 mx-auto my-10'>
            <h3 className='mb-5 text-xl font-bold'>
                Resultado da Busca - {search.query}
            </h3>

            <span className='text-[#5f5f5f]'>
                {search.result.length} {search.result.length > 1 ? 'resultados' : 'resultado'}
            </span>

            <ul className='mt-10 grid gap-8'>
                {search.result.map(({ question, answer }) => (
                    <li className='grid gap-4'>
                        <span className='text-salmon font-semibold uppercase'>{question}</span>

                        <div
                            className='institutional-hyperlinks text-[#5f5f5f]'
                            dangerouslySetInnerHTML={{ __html: answer }}
                        />
                    </li>
                ))}
            </ul>
        </div>
    )
}
